import flatMap from 'lodash/flatMap';

import {
	RecipientOption,
	Recipient,
	IUserRecipient,
	isUserRecipient,
} from 'packages/kakapo-ui-services/models/Recipient';

export default class RecipientService {
	/**
	 * Filters previously added user options from the given array. Email options will not be filtered
	 */
	static filterPreviouslyAddedOptions = (
		rawOptions: Array<RecipientOption>,
		recipients: Array<Recipient>,
	): Array<RecipientOption> => {
		const selectedOptionValues: Array<string> = flatMap(recipients, (recipient) => {
			if (isUserRecipient(recipient) === true) {
				return (recipient as IUserRecipient).userId;
			}
			// Arrays will be flattened and thus be ignored
			return [];
		});

		return rawOptions.filter((option) => {
			return !selectedOptionValues.includes(option.value);
		});
	};
}
